import "./certifications.css";
import Timeline from "../../../timeline/Timeline";
import Heading from "../../../heading/Heading";
import { certificationsData } from "../../../../data/CertificationsData";

const Certifications = () => {
  return (
    <div className="certifications">
      <Heading word="Certification" headingSize="h3" />
      <div className="d-flex flex-column justify-content-center align-items-center">
        {certificationsData.map((certification) => {
          return (
            <Timeline
              timelineName="certification"
              {...certification}
              key={certification.id}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Certifications;
